export class LogFilterModel {
  timeStamp: Date | null = null;
  timeStampFinal: Date | null = null;
  message: string = "";
  userName: string = "";
  service: string = "";
  method: string = "";
}
